var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKick = function SvgKick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 4a1 1 0 0 1 1-1h14.501a1 1 0 0 1 1 1v9.11a1 1 0 0 0 1 1h3.498a1 1 0 0 0 1-1V9.555a1 1 0 0 1 1-1h3.5a1 1 0 0 0 1-1V4a1 1 0 0 1 1-1H49a1 1 0 0 1 1 1v14.668a1 1 0 0 1-1 1h-3.5a1 1 0 0 0-1 1v3.555a1 1 0 0 1-1 1H40a1 1 0 0 0-1 1v3.555a1 1 0 0 0 1 1h3.5a1 1 0 0 1 1 1v3.555a1 1 0 0 0 1 1H49a1 1 0 0 1 1 1V52a1 1 0 0 1-1 1H34.499a1 1 0 0 1-1-1v-3.555a1 1 0 0 0-1-1h-3.5a1 1 0 0 1-1-1V42.89a1 1 0 0 0-1-1h-3.495a1 1 0 0 0-1 1V52a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z",
    clipRule: "evenodd"
  })));
};
export default SvgKick;